module.exports = __webpack_public_path__ + "img/24.9eeba955.png";